// Empty module to replace Node.js polyfills that are not needed in the browser
// This helps reduce bundle size by preventing crypto-browserify and similar polyfills
module.exports = {};
